/** API авторизации клиентского портала. */
import { apiClient } from './index'
import type { ClientProfile, LoginPayload, LoginResponse } from '@/types/auth'

export const authApi = {
  /** POST /api/portal/auth/login/ */
  login(payload: LoginPayload): Promise<LoginResponse> {
    return apiClient.post<LoginResponse>('/portal/auth/login/', payload)
  },

  /** POST /api/portal/auth/logout/ — отзыв токена. */
  logout(): Promise<void> {
    return apiClient.post<void>('/portal/auth/logout/')
  },

  /** GET /api/portal/auth/me/ — данные текущего клиента. */
  me(): Promise<ClientProfile> {
    return apiClient.get<ClientProfile>('/portal/auth/me/')
  },
}
